module.exports = __webpack_public_path__ + "static/img/01_02.0254ed19.jpg";